import React, { useState, useEffect } from 'react';
import { Calendar, Check, Lock } from 'lucide-react';
import { getDailyChallenges, isChallengeCompleted } from '../../utils/gamificationManager';

const DailyChallenge = ({ profileId, onChallengeClick }) => {
  const [challenges, setChallenges] = useState([]);

  useEffect(() => {
    const dailyChallenges = getDailyChallenges();
    const challengesWithStatus = dailyChallenges.map(challenge => ({
      ...challenge,
      completed: isChallengeCompleted(profileId, challenge.id)
    }));
    setChallenges(challengesWithStatus);
  }, [profileId]);

  const completedCount = challenges.filter(c => c.completed).length;
  const totalCount = challenges.length;

  return (
    <div className="daily-challenge-container">
      <div className="daily-challenge-header">
        <div className="header-title">
          <Calendar size={24} color="#3498db" />
          <h3>Daily Challenges</h3>
        </div>
        <div className="challenge-progress">
          {completedCount}/{totalCount} Complete
        </div>
      </div>

      <div className="challenges-list">
        {challenges.map((challenge, index) => (
          <div
            key={challenge.id}
            className={`challenge-card ${challenge.completed ? 'completed' : ''} animate-slideInLeft`}
            style={{ 
              animationDelay: `${index * 0.1}s`,
              borderLeftColor: challenge.color 
            }}
            onClick={() => onChallengeClick && onChallengeClick(challenge)}
          >
            <div className="challenge-icon" style={{ background: challenge.color }}>
              {challenge.completed ? (
                <Check size={24} color="white" />
              ) : (
                <span className="challenge-emoji">{challenge.icon}</span>
              )}
            </div>

            <div className="challenge-info">
              <h4 className="challenge-name">{challenge.name}</h4>
              <p className="challenge-description">{challenge.description}</p>
            </div>

            <div className="challenge-reward">
              <div className="reward-amount">+{challenge.xpReward}</div>
              <div className="reward-label">XP</div>
            </div>

            {challenge.completed && (
              <div className="completed-badge">
                <Check size={16} />
              </div>
            )}
          </div>
        ))}
      </div>

      {completedCount === totalCount && totalCount > 0 && (
        <div className="all-complete-banner animate-pulse">
          <span className="banner-icon">🎉</span>
          <span className="banner-text">All challenges complete! Come back tomorrow!</span>
        </div>
      )}
    </div>
  );
};

export default DailyChallenge;
